import { render } from "./PriceModel.vue?vue&type=template&id=5666c1c8&scoped=true"
import script from "./PriceModel.vue?vue&type=script&lang=js"
export * from "./PriceModel.vue?vue&type=script&lang=js"

import "./PriceModel.vue?vue&type=style&index=0&id=5666c1c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5666c1c8"]])

export default __exports__